import React from 'react';
import IconButtonMUI from '../../../../shared/IconButtonMUI';
import {ReactComponent as UseAddIcon} from '../../../../assets/icons/user-add.svg';
import {ReactComponent as BackIcon} from '../../../../assets/icons/back.svg';
import {ReactComponent as MuteSvg} from '../../../../assets/icons/mute.svg';
import './CompaniesHero.scss';
import {useTranslation} from 'react-i18next';

const CompaniesHero = ({
  heading,
  subHeading,
  handleAdd,
  handleList,
  selectedBack,
  handleNotificationRead,
  selectedList,
  notification,
  disabledActionAdd = false
}) => {
  const {t} = useTranslation();
  return (
    <div className='companies-hero__head'>
      <div className='companies-hero__head-actions'>
        {selectedBack && (
          <IconButtonMUI color='primary' onClick={handleList} title={t('AvatarPopup.return')}>
            <BackIcon />
          </IconButtonMUI>
        )}
        <div className='companies-hero__head-info'>
          <div className='companies-hero__head-count'>{heading && heading}</div>
          <div className='companies-hero__head-title'>{subHeading && subHeading}</div>
        </div>
      </div>
      {selectedList && !disabledActionAdd && (
        <IconButtonMUI onClick={handleAdd} title={t('ProjectsParticipantsAdd.add')}>
          <UseAddIcon />
        </IconButtonMUI>
      )}

      {notification && (
        <IconButtonMUI onClick={handleNotificationRead} title={t('all.mute')}>
          <MuteSvg />
        </IconButtonMUI>
      )}
    </div>
  );
};

export default CompaniesHero;
